export const APPROVAL_FORM_IDS = {
  WORK_SCHEDULE: 10,
  WORKING_TIME_CHANGE: 11,
  WORK_POLICY_APPLICATION: 12
} as const;

export type ApprovalFormSurface = "desktop" | "mobile";
export type ApprovalFormRenderer =
  | "legacy"
  | "work-policy-application"
  | "unsupported";
export type ApprovalFormDataAdapter =
  | "legacy-graphql"
  | "work-policy-application-rest"
  | "unsupported";

export interface ApprovalFormDescriptor {
  formIdx: number | null;
  key:
    | keyof typeof APPROVAL_FORM_IDS
    | "UNSUPPORTED";
  renderer: ApprovalFormRenderer;
  detailLoader: ApprovalFormDataAdapter;
  saveAdapter: ApprovalFormDataAdapter;
  desktopOnly: boolean;
  productionRendererEnabled: boolean;
}

const UNSUPPORTED_FORM: ApprovalFormDescriptor = {
  formIdx: null,
  key: "UNSUPPORTED",
  renderer: "unsupported",
  detailLoader: "unsupported",
  saveAdapter: "unsupported",
  desktopOnly: false,
  productionRendererEnabled: false
};

const APPROVAL_FORM_REGISTRY: Readonly<Record<number, ApprovalFormDescriptor>> = {
  [APPROVAL_FORM_IDS.WORK_SCHEDULE]: {
    formIdx: APPROVAL_FORM_IDS.WORK_SCHEDULE,
    key: "WORK_SCHEDULE",
    renderer: "legacy",
    detailLoader: "legacy-graphql",
    saveAdapter: "legacy-graphql",
    desktopOnly: false,
    productionRendererEnabled: true
  },
  [APPROVAL_FORM_IDS.WORKING_TIME_CHANGE]: {
    formIdx: APPROVAL_FORM_IDS.WORKING_TIME_CHANGE,
    key: "WORKING_TIME_CHANGE",
    renderer: "legacy",
    detailLoader: "legacy-graphql",
    saveAdapter: "legacy-graphql",
    desktopOnly: false,
    productionRendererEnabled: true
  },
  [APPROVAL_FORM_IDS.WORK_POLICY_APPLICATION]: {
    formIdx: APPROVAL_FORM_IDS.WORK_POLICY_APPLICATION,
    key: "WORK_POLICY_APPLICATION",
    renderer: "work-policy-application",
    detailLoader: "work-policy-application-rest",
    saveAdapter: "work-policy-application-rest",
    desktopOnly: true,
    productionRendererEnabled: true
  }
};

export function getApprovalFormDescriptor(formIdx: number): ApprovalFormDescriptor {
  return APPROVAL_FORM_REGISTRY[formIdx] ?? UNSUPPORTED_FORM;
}

export function resolveApprovalFormDescriptor(
  formIdx: number,
  surface: ApprovalFormSurface
): ApprovalFormDescriptor {
  const descriptor = getApprovalFormDescriptor(formIdx);
  return descriptor.desktopOnly && surface !== "desktop"
    ? UNSUPPORTED_FORM
    : descriptor;
}

export function resolveProductionApprovalForm(
  formIdx: number
): ApprovalFormDescriptor {
  const descriptor = resolveApprovalFormDescriptor(formIdx, "desktop");
  return descriptor.productionRendererEnabled ? descriptor : UNSUPPORTED_FORM;
}
